import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { URL_CONFIG } from "@src/config/urlConfig";

function QrCodeUrl() {
  return (
    <div
      style={{
        maxWidth: 350,
        margin: "2rem auto",
        padding: 32,
        borderRadius: 12,
        background: "#f8fafc",
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <QRCodeCanvas value={URL_CONFIG.BASE_URL} size={192} />
      </div>
    </div>
  );
}

export default QrCodeUrl;
